function formatDecimal(value) {
  return +value.toFixed(30);
}
function prepareForDataBetForDb(bets) {
  return bets.map((bet) => ({
    ...bet,
    commission: formatDecimal(bet.commission),
    backStake: formatDecimal(bet.backStake),
    chance: formatDecimal(bet.chance),
    stake: formatDecimal(bet.stake),
    profit: formatDecimal(bet.profit)
  }));
}
export {
  prepareForDataBetForDb
};